import React, { memo, useEffect, useState } from 'react';
import '../../css/RequestRemedyForm.css';
import { useDispatch, useSelector } from 'react-redux';
import { RequestsActions } from '../../_store/Requests.slice';
import CustomModal from '../../components/common/CustomModal ';
import Button from '../../components/common/ui/Button';
import CheckBoxInput from '../../components/common/ui/Inputs/CheckBoxInput';
import TextAreaInput from '../../components/common/ui/Inputs/TextAreaInput';
import RequestRemedyFormSchema from '../../validation/RequestRemedyFormSchema';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import TranslateFile from '../../Loc/TranslateFile';
import Loader from '../../components/common/Loader';
import { getStoredValue  } from "../../_helpers/storageHelper";

const RequestRemedyForm = ({ handleBack, isEdit, selectrowItem }) => {
    const initialFormData = {
        grvOriginal: false, grvGrvAppeal: false, grvDisciplinaryActionAppeal: false,
        grievanceDescription: '', RequestCreateDate: '', PodCode: '', isshowInvestigationinfo: false
    }
    const [formData, setFormData] = useState(initialFormData);
    const [prevDescription, setprevDescription] = useState();
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const { RequestAdminRemedyCUDResponse, InmateRequestAdminRemedyResponse } = useSelector(state => state.Requests);
    const [errorMessage, setErrorMessage] = useState({});
    const [issubmit, setissubmit] = React.useState(false);
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setmodalContent] = useState("");
    const [modalContentColor, setmodalContentColor] = useState("");
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const currentLang = TranslateFile();
    const [isLoading, setisLoading] = React.useState(false);

    useEffect(() => {
        if (isEdit) {
            if (selectrowItem?.RequestFormType == 2) {
                setisLoading(true);
                dispatch(RequestsActions.loadInmateRequestAdminRemedy(selectrowItem?.RequestFormTypeID)).then(() => {
                    setisLoading(false);
                });
            }
        }
    }, [isEdit]);

    const handleupdatedata = () => {
        if (isEdit && InmateRequestAdminRemedyResponse?.length > 0 && InmateRequestAdminRemedyResponse[0]?.RequestAdminRemedyID) {
            setFormData({
                grvOriginal: InmateRequestAdminRemedyResponse[0]?.GrvOriginal == 1 ? true : false,
                grvGrvAppeal: InmateRequestAdminRemedyResponse[0]?.GrvAppeal == 1 ? true : false,
                grvDisciplinaryActionAppeal: InmateRequestAdminRemedyResponse[0]?.GrvDisciplinaryActionAppeal == 1 ? true : false,
                grievanceDescription: InmateRequestAdminRemedyResponse[0]?.GrievanceBody,
                RequestCreateDate: InmateRequestAdminRemedyResponse[0]?.RequestCreateDate,
                PodCode: InmateRequestAdminRemedyResponse[0]?.PodCode,
                isshowInvestigationinfo: InmateRequestAdminRemedyResponse[0]?.GrievanceReceivedUserID != 0 ? true : false
            })
        }
    }

    useEffect(() => {
        handleupdatedata();
    }, [InmateRequestAdminRemedyResponse]);

    const getCurrentDate = () => {
        const today = new Date();
        return today.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleKeyPress = (button) => {
        if (button === "{accept}" || button === "{enter}" || button === "{prev}" || button === "{next}" || button === "{cancel}") {
            setIsKeyboardOpen(false);
        }
        else if (button === "{backspace}") {
            setFormData(prevData => ({
                ...prevData,
                grievanceDescription: prevData.grievanceDescription.slice(0, -1) // Remove last character
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrorMessage({});
        const { error } = RequestRemedyFormSchema(formData);
        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }
        if (!formData?.grvOriginal && !formData?.grvGrvAppeal && !formData?.grvDisciplinaryActionAppeal) {
            setmodalContent(currentLang?.AlertPopup?.One_Grievance_Item); setmodalContentColor('#c8605e');
            setShowPopup(true);
            return;
        }
        var Objectdata = {
            requestAdminRemedyID: isEdit ? selectrowItem?.RequestFormTypeID : 0, inmateResidentID: storedloginResponse?.InmatesResdId, podCode: storedLoginDetails?.PodCode, bookingNo: '', inmateCellNo: '',
            grvOriginal: formData?.grvOriginal == true ? 1 : 0,
            grvGrvAppeal: formData?.grvGrvAppeal == true ? 1 : 0,
            grvDisciplinaryActionAppeal: formData?.grvDisciplinaryActionAppeal == true ? 1 : 0,
            grievanceBody: formData?.grievanceDescription, action: isEdit ? 2 : 1,
            facilityID: storedloginResponse?.facilityID, inmatesId: storedloginResponse?.InmateID,
        };
        dispatch(RequestsActions.loadRequestAdminRemedyCUD(Objectdata));
        setissubmit(true)

    };

    useEffect(() => {
        if (RequestAdminRemedyCUDResponse?.length !== 0 && issubmit) {
            switch (RequestAdminRemedyCUDResponse) {
                case 1:
                    setmodalContent(currentLang?.AlertPopup?.Request_Submit_Success); setmodalContentColor('#4a9a93');
                    break;
                case 2:
                    setmodalContent(currentLang?.AlertPopup?.Remedy_Form_Submit_Success); setmodalContentColor('#4a9a93')
                    break;
                case -1:
                    setmodalContent(currentLang?.AlertPopup?.Please_Try_Again); setmodalContentColor('#c8605e')
                    break;
                case -2:
                    setmodalContent(currentLang?.AlertPopup?.One_Grievance_Item); setmodalContentColor('#c8605e')
                    break;
            }
            setShowPopup(true); setissubmit(false);
        }
    }, [RequestAdminRemedyCUDResponse]);

    return (
        <>
            {isLoading && <Loader />}
            <div className="panel panel-default">
                <div className="panel-heading">{currentLang?.Requests?.Request_Remedy_Form}</div>
                <div className="panel-body" >
                    <h4 className="form-SubTitle">{currentLang?.Requests?.Inmate_Info}</h4>
                    <div className="row">
                        <div className="row col-md-12">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible text-gray">{currentLang?.Requests?.Name}</label>
                                    <p className='font-size-15 fw-500'>{storedloginResponse?.InmateFullName}</p>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible text-gray">{currentLang?.Requests?.Inmate_ID}</label>
                                    <p className='font-size-15 fw-500'>{storedloginResponse?.InmatesResdId}</p>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible text-gray">{currentLang?.Requests?.Date}</label>
                                    <p className='font-size-15 fw-500'>{formData?.RequestCreateDate ? formData?.RequestCreateDate : getCurrentDate()}</p>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible text-gray">{currentLang?.Requests?.Pod}</label>
                                    <p className='font-size-15 fw-500'>{formData?.PodCode ? formData?.PodCode : storedLoginDetails?.PodCode}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row col-md-12">
                        </div>
                        <div className="col-md-6" style={{ display: 'none' }}>
                            <div className="form-group">
                                <label>{currentLang?.Requests?.Cell}</label>
                                <input
                                    type="text"
                                    name="cellNo"
                                    value={formData.cellNo}
                                    className="form-control"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <h4 className="form-SubTitle">{currentLang?.Requests?.Grievance_Info}</h4>
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Grievance}<span className="mandatory">*</span></label>
                            <div className="row">
                                <div className="col-md-3">
                                    <CheckBoxInput
                                        label={currentLang?.Requests?.Original}
                                        name="grvOriginal"
                                        id={'grvOriginal'}
                                        handleClick={handleChange}
                                        checked={formData?.grvOriginal}
                                        disabled={formData?.isshowInvestigationinfo}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <CheckBoxInput
                                        label={currentLang?.Requests?.Appeal}
                                        name="grvGrvAppeal"
                                        id={'grvGrvAppeal'}
                                        handleClick={handleChange}
                                        checked={formData?.grvGrvAppeal}
                                        disabled={formData?.isshowInvestigationinfo}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <CheckBoxInput
                                        label={currentLang?.Requests?.Disciplinary_Action_Appeal}
                                        name="grvDisciplinaryActionAppeal"
                                        handleClick={handleChange}
                                        id={'grvDisciplinaryActionAppeal'}
                                        checked={formData?.grvDisciplinaryActionAppeal}
                                        disabled={formData?.isshowInvestigationinfo}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    {formData?.isshowInvestigationinfo ? <form >
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Description}<span className="mandatory">*</span></label>
                                <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{formData.grievanceDescription}</label>
                            </div></div>
                        <div className="row col-md-12">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Received_By}</label>
                                    <input
                                        type="text"
                                        name="Received By"
                                        value={InmateRequestAdminRemedyResponse[0]?.GrievanceReceivedUser}
                                        className="form-control"
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Date_Received}</label>
                                    <input
                                        type="text"
                                        name="inmateId"
                                        value={InmateRequestAdminRemedyResponse[0]?.GrievanceReceivedDate}
                                        className="form-control"
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="form-row">
                                <CheckBoxInput
                                    label={"Forwarded"}
                                    name="Forwarded"
                                    disabled={true}
                                    checked={InmateRequestAdminRemedyResponse[0]?.GrievanceForward}
                                />
                            </div>

                        </div>
                        <h4 className="form-SubTitle">{currentLang?.Requests?.Investigation_Info}</h4>
                        <div className="row col-md-12">
                            <div className="col-md-6">
                                <div>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Investigation}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.InvestigationBody || "NA"}</label>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Completed_By}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.InvestigationCompletedByUser} </label>

                                </div>
                            </div>
                        </div>
                        <h4 className="form-SubTitle">{currentLang?.Requests?.Review_Findings_Info}</h4>

                        <div className="row col-md-12">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Review_Findings}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.ReviewFindingsBody || "NA"}</label>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Date}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.GrievanceReceivedDate}</label>
                                </div>
                            </div>
                        </div>

                        <div className="row col-md-12">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Supervisor_Signature}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.SupervisorSignature || "NA"}</label>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Title}</label>
                                    <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible font-weight-500">{InmateRequestAdminRemedyResponse[0]?.SupervisorTitle || "NA"}</label>

                                </div>
                            </div>
                        </div>

                    </form> :
                        <>
                            <div className="col-md-12">
                                <div className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
                                    <TextAreaInput
                                        name="grievanceDescription"
                                        id="grievanceDescription"
                                        label={currentLang?.Requests?.Description}
                                        value={formData.grievanceDescription}
                                        handleChange={handleChange}
                                        onClick={() => { setIsKeyboardOpen(true); setprevDescription(formData.grievanceDescription) }}
                                        placeholder={currentLang?.Requests?.Description_Placeholder}
                                        required={true}
                                        disabled={isEdit}
                                        errorMessage={errorMessage}
                                        rows={4}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-30">
                                <Button label={currentLang?.Buttons?.Submit} className='me-2' status="primary" type="submit" onClick={handleSubmit} disabled={issubmit} isLoading={issubmit} />
                                <Button label={currentLang?.Buttons?.Reset} className="btn btn-warning" type="button" onClick={() => {
                                    if (isEdit) {
                                        handleupdatedata();
                                    } else {
                                        setFormData(initialFormData); setErrorMessage({})
                                    }
                                }} />
                            </div>
                        </>
                    }

                </div>
                {isKeyboardOpen && (
                    <div className="card-default">
                        <CustomKeyboard
                            onInputChange={(value) => {
                                setFormData(prevData => ({
                                    ...prevData,
                                    grievanceDescription: value // Update the whoSent field
                                }));
                                setErrorMessage({
                                    ...errorMessage,
                                    grievanceDescription: value.trim()?.length > 0 ? "" : currentLang?.ValidationSchema?.Grievance_Description_Required
                                })
                            }}
                            inputValue={formData.grievanceDescription}
                            onKeyPress={handleKeyPress}
                            handleCancel={() => {
                                setFormData(prevData => ({
                                    ...prevData,
                                    grievanceDescription: prevDescription // Update the whoSent field
                                })); setIsKeyboardOpen(false)
                            }}
                            isEnterfunction={true}
                            setShowBoard={setIsKeyboardOpen}
                            placeholder={currentLang?.Requests?.Description_Placeholder}
                        />
                    </div>
                )}
                {showPopup && (
                    <CustomModal
                        color={modalContentColor}
                        content={modalContent}
                        onOkClick={() => { modalContent == currentLang?.AlertPopup?.One_Grievance_Item ? setShowPopup(false) : handleBack() }}
                    />
                )}
            </div>
        </>
    );
};

export default memo(RequestRemedyForm);
